package com.kaihuoy.web

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.database.database
import dev.gitlive.firebase.functions.functions
import dev.gitlive.firebase.storage.storage
import dev.gitlive.firebase.initialize

object FirebaseService {
    val options = FirebaseOptions(
        applicationId = "1:414350774936:web:701df93a0ec540d89f76ed",
        apiKey = "AIzaSyCe-rZPpeeFXbqu85UUQc2Ed2lR_Vaw12w",
        authDomain = "kuormakirja-75150.firebaseapp.com",
        databaseUrl = "https://kuormakirja-75150-default-rtdb.europe-west1.firebasedatabase.app",
        projectId = "kuormakirja-75150",
        storageBucket = "kuormakirja-75150.firebasestorage.app"
    )

    val app by lazy { Firebase.initialize(options = options) }
    val auth by lazy { Firebase.auth(app) }
    val database by lazy { Firebase.database(app) }
    val storage by lazy { Firebase.storage(app) }
    val functions by lazy { Firebase.functions(app, "europe-west1") }
}